module.exports = __webpack_public_path__ + "media/src/public/img/apple-touch-icon-067770124fbf7aa2365ac13ee53da9b7.png";